import { Dumbbell, Laptop, CalendarDays, CheckCircle,FileText } from "lucide-react";
import { motion } from "framer-motion";

const PricingSection = () => {
  const cards = [
    {
      icon: <Dumbbell className="text-brandGreen w-6 h-6" />,
      title: "Trening Indywidualny",
      price: "149 zł",
      extras: [
        "1:1 z trenerem w siłowni",
        "Pełne wsparcie i korekta techniki",
        "Trening dopasowany do Twojego celu",
        "Motywacja i indywidualne podejście",
      ],
    },
       {
      icon: <FileText className="text-brandGreen w-6 h-6" />,
      title: "Plan treningowy",
      price: "199 zł",
      extras: [
        "Indywidualnie dopasowany plan",
        "Ułożony przez certyfikowanego trenera",
        "Uwzględnia cele i możliwości",
        "Wygodny dostęp online",
      ],
    },
    {
      icon: <Laptop className="text-brandGreen w-6 h-6" />,
      title: "Opieka online",
      price: "249 zł",
      sub: "/ 1 miesiąc",
      extras: [
        "Pomoc 24/7",
        "Plan treningowy",
        "Dopasowanie do celów",
        "Monitoring postępów",
      ],
    },
    {
      icon: <CalendarDays className="text-brandGreen w-6 h-6" />,
      title: "Pakiet 10 treningów",
      price: "1299 zł",
      sub: "/ pakiet",
      extras: [
        "10 treningów personalnych",
        "Darmowa konsultacja",
        "Plan treningowy w zestawie",
        "Elastyczny grafik",
      ],
    },

  ];

  return (
    <section className="py-20 bg-brandLight" id="pricing">
      <div className="max-w-7xl mx-auto px-4 text-center">
        <h3 className="text-4xl font-bold text-brandDark mb-12">Cennik</h3>

        <div className="grid md:grid-cols-4 gap-3">
          {cards.map((card, i) => (
            <motion.div
              key={i}
              layout
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{
                duration: 1,
                ease: [0.25, 1, 0.5, 1],
                delay: i * 0.2,
              }}
              viewport={{ once: true, amount: 1 }}
              className="bg-white rounded-2xl p-8 text-left text-brandDark border border-gray-200 shadow-sm hover:shadow-md transition flex flex-col"
            >
              <div className="flex items-center gap-2 mb-4">
                {card.icon}
                <h4 className="text-xl font-semibold">{card.title}</h4>
              </div>

              <p className="text-3xl font-bold mb-2 text-brandGreen">
                {card.price}
                {card.sub && (
                  <span className="text-sm font-normal text-textMuted"> {card.sub}</span>
                )}
              </p>

              <p className="text-sm mb-4 text-textMuted">Co zawiera?</p>
              <ul className="space-y-2 mb-6">
                {card.extras.map((text, idx) => (
                  <li key={idx} className="flex items-start gap-2">
                    <CheckCircle className="w-4 h-4 text-brandGreen shrink-0 self-start mt-1" />
                    <span>{text}</span>
                  </li>
                ))}
              </ul>

              <div className="text-center mt-auto pt-4">
                <a
                  href="#contact"
                  className="inline-block bg-brandGreen text-white font-semibold py-2 px-6 rounded-lg hover:bg-brandGreenDark transition"
                >
                  Skontaktuj się
                </a>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
